// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crypto-section {
  background: #ffffff;
  padding: 30px;
  border-radius: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04);
  max-width: 900px;
  /* margin: 20px auto; */
  font-family: 'Inter', sans-serif;
}

.table-header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.table-main-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.live-indicator {
  background: rgba(66, 182, 147, 0.1);
  color: #42b693;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
}

.custom-table-container {
  overflow-x: auto;
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.modern-table th {
  padding: 12px 15px;
  color: #94a3b8;
  font-size: 13px;
  text-transform: uppercase;
  font-weight: 600;
  border-bottom: 1px solid #f1f5f9;
}

.modern-table td {
  padding: 16px 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
}

.coin-flex {
  display: flex;
  align-items: center;
  gap: 12px;
}

.coin-avatar {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 18px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.coin-full-name {
  display: block;
  font-weight: 700;
  color: #1e293b;
  font-size: 15px;
}

.coin-ticker {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
}

.badge {
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
}

.badge.up {
  background: #ecfdf5;
  color: #10b981;
}

.badge.down {
  background: #fef2f2;
  color: #ef4444;
}

.td-price {
  font-family: 'Roboto Mono', monospace;
  font-weight: 700;
  color: #0f172a;
  font-size: 16px;
}

.source-tag {
  margin-top: 20px;
  font-size: 12px;
  color: #cbd5e1;
  text-align: center;
}

/* Анимация при обновлении данных */
.table-row-animate {
  transition: all 0.3s ease;
}

.table-row-animate:hover {
  background: #f8fafc;
  transform: scale(1.01);
}

/* Основной контейнер */
.crypto-section-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  /* padding: 0 15px; */
  box-sizing: border-box;
  overflow: hidden; /* Гарантирует отсутствие скролла */
}

.crypto-section {
  background: #ffffff;
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04);
}

.custom-table-wrapper {
  width: 100%;
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
}

.text-right { text-align: right; }

/* Стили для мобильных устройств (Адаптив) */
@media (max-width: 600px) {
  .hide-mobile {
    display: none; /* Прячем колонку с номером # на мобилках */
  }

  .crypto-section {
    padding: 1px;
    border-radius: 20px;
  }

  .table-main-title {
    font-size: 18px;
  }

  .modern-table th {
    font-size: 11px;
    padding: 10px 5px;
  }

  .modern-table td {
    padding: 12px 5px;
  }

  .coin-avatar {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }

  .coin-full-name {
    font-size: 14px;
  }

  .td-price {
    font-size: 14px;
  }

  .badge {
    padding: 4px 8px;
    font-size: 12px;
  }
}

/* Плавный эффект при наведении */
.table-row-animate {
  transition: background 0.2s ease;
}

.table-row-animate:hover {
  background: #f8fafc;
}

.custom-table-wrapper {
  width: 100%;
  overflow-x: auto; /* Включаем горизонтальный скролл на мобилках */
  -webkit-overflow-scrolling: touch;
}

.modern-table {
  width: 100%;
  min-width: 400px; /* Чтобы таблица не сжималась в кашу */
  border-collapse: collapse;
}

/* Скрываем колонку # и Изменение на очень маленьких экранах */
@media (max-width: 600px) {
  .hide-mobile {
    display: none;
  }
  
  .td-price {
    font-size: 14px;
  }

  .coin-full-name {
    font-size: 13px;
  }
  
  .table-main-title {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/CoinPriceTable.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,cAAc,iBAAiB,EAAE;;AAEjC,4CAA4C;AAC5C;EACE;IACE,aAAa,EAAE,2CAA2C;EAC5D;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,iCAAiC;AACjC;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,+CAA+C;EACjE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,sCAAsC;EACxD,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".crypto-section {\n  background: #ffffff;\n  padding: 30px;\n  border-radius: 24px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04);\n  max-width: 900px;\n  /* margin: 20px auto; */\n  font-family: 'Inter', sans-serif;\n}\n\n.table-header-flex {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n}\n\n.table-main-title {\n  font-size: 22px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.live-indicator {\n  background: rgba(66, 182, 147, 0.1);\n  color: #42b693;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n\n.custom-table-container {\n  overflow-x: auto;\n}\n\n.modern-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n}\n\n.modern-table th {\n  padding: 12px 15px;\n  color: #94a3b8;\n  font-size: 13px;\n  text-transform: uppercase;\n  font-weight: 600;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.modern-table td {\n  padding: 16px 15px;\n  border-bottom: 1px solid #f8fafc;\n  vertical-align: middle;\n}\n\n.coin-flex {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.coin-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: bold;\n  font-size: 18px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n}\n\n.coin-full-name {\n  display: block;\n  font-weight: 700;\n  color: #1e293b;\n  font-size: 15px;\n}\n\n.coin-ticker {\n  font-size: 12px;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.badge {\n  padding: 5px 10px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.badge.up {\n  background: #ecfdf5;\n  color: #10b981;\n}\n\n.badge.down {\n  background: #fef2f2;\n  color: #ef4444;\n}\n\n.td-price {\n  font-family: 'Roboto Mono', monospace;\n  font-weight: 700;\n  color: #0f172a;\n  font-size: 16px;\n}\n\n.source-tag {\n  margin-top: 20px;\n  font-size: 12px;\n  color: #cbd5e1;\n  text-align: center;\n}\n\n/* Анимация при обновлении данных */\n.table-row-animate {\n  transition: all 0.3s ease;\n}\n\n.table-row-animate:hover {\n  background: #f8fafc;\n  transform: scale(1.01);\n}\n\n/* Основной контейнер */\n.crypto-section-container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  /* padding: 0 15px; */\n  box-sizing: border-box;\n  overflow: hidden; /* Гарантирует отсутствие скролла */\n}\n\n.crypto-section {\n  background: #ffffff;\n  border-radius: 24px;\n  padding: 24px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04);\n}\n\n.custom-table-wrapper {\n  width: 100%;\n}\n\n.modern-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.text-right { text-align: right; }\n\n/* Стили для мобильных устройств (Адаптив) */\n@media (max-width: 600px) {\n  .hide-mobile {\n    display: none; /* Прячем колонку с номером # на мобилках */\n  }\n\n  .crypto-section {\n    padding: 1px;\n    border-radius: 20px;\n  }\n\n  .table-main-title {\n    font-size: 18px;\n  }\n\n  .modern-table th {\n    font-size: 11px;\n    padding: 10px 5px;\n  }\n\n  .modern-table td {\n    padding: 12px 5px;\n  }\n\n  .coin-avatar {\n    width: 32px;\n    height: 32px;\n    font-size: 16px;\n  }\n\n  .coin-full-name {\n    font-size: 14px;\n  }\n\n  .td-price {\n    font-size: 14px;\n  }\n\n  .badge {\n    padding: 4px 8px;\n    font-size: 12px;\n  }\n}\n\n/* Плавный эффект при наведении */\n.table-row-animate {\n  transition: background 0.2s ease;\n}\n\n.table-row-animate:hover {\n  background: #f8fafc;\n}\n\n.custom-table-wrapper {\n  width: 100%;\n  overflow-x: auto; /* Включаем горизонтальный скролл на мобилках */\n  -webkit-overflow-scrolling: touch;\n}\n\n.modern-table {\n  width: 100%;\n  min-width: 400px; /* Чтобы таблица не сжималась в кашу */\n  border-collapse: collapse;\n}\n\n/* Скрываем колонку # и Изменение на очень маленьких экранах */\n@media (max-width: 600px) {\n  .hide-mobile {\n    display: none;\n  }\n  \n  .td-price {\n    font-size: 14px;\n  }\n\n  .coin-full-name {\n    font-size: 13px;\n  }\n  \n  .table-main-title {\n    font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
